import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useShangpinUpdateQuery, useShangpinUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
function GoodsEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useShangpinUpdateQuery({sp_id:props.sp_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    sp_hyt_name:data.Result.sp_hyt_name,
                    sp_qyt_name:data.Result.sp_qyt_name,
                    sp_wz:data.Result.sp_wz,
                    sp_name:data.Result.sp_name,
                    sp_content:data.Result.sp_content,
                    sp_image:[data.Result.sp_image],
                })
                setInfo(prevState=>({...prevState,
                    sp_hyt_id:data.Result.sp_hyt_id,
                    sp_hyt_name:data.Result.sp_hyt_name,
                    sp_qyt_name:data.Result.sp_qyt_name,
                    sp_qyt_id:data.Result.sp_qyt_id,
                    sp_wz:data.Result.sp_wz,
                    sp_name:data.Result.sp_name,
                    sp_content:data.Result.sp_content,        
                    sp_image:data.Result.sp_image,        
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useShangpinUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改商品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "sp_content" : info.sp_content,
                        "sp_id" : props.sp_id,
                        "sp_name" : info.sp_name,
                        'sp_uid': localStorage.getItem('eu_id'),
                        'sp_uname': localStorage.getItem('eu_name'),
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="sp_name" wrapperCol={{span:10}} required label='商品名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,sp_name:e.target.value}))
                        }}/>
                    </Form.Item>                        
                    <Form.Item name="sp_content" wrapperCol={{span:10}} label='备注'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,sp_content:e.target.value}))
                        }}/>
                    </Form.Item>    
                </Form>
            </Modal>
        </>
    )
}

export default GoodsEdit